import { Route } from "react-router-dom";
import ExecutiveDashboard from "../../../pages/Views/ExecutiveView/ExecutiveDashboard";
import ExecActivities from "../../../pages/Views/ExecutiveView/Reports/ExecActivities";
import ExecFinance from "../../../pages/Views/ExecutiveView/Reports/ExecFinance";
//import MapDataProvider from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/MapData/MapDataProvider";
import ViewMapByCategoryPage from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/Views/ViewMapByCategoryPage";
import ExecutiveReport from "../../../pages/Views/ExecutiveView/Reports/ExecutiveReport";
import ViewReferredStatus from "../../../pages/Views/EICView/Forms/ViewReferredStatus";
import ExecRuleSettings from "../../../pages/Views/ExecutiveView/Forms/ExecRuleSettings";
import PlaceParcelOnHold from "../../../pages/Views/ExecutiveView/Forms/PlaceParcelOnHold";
import EmploymentReport from "../../../pages/Views/OperationAndManagement/Reports/EmploymentReport";
import TradeReport from "../../../pages/Views/OperationAndManagement/Reports/TradeReport";
// import InvestorList from "../../../pages/Views/Shared/Report/List/InvestorList";
//the following import is added
import PlaceParcelOnHoldRelease from "../../../pages/Views/ExecutiveView/Forms/PlaceParcelOnHoldRelease";
// import { FinancialSummaryReport } from "../../../pages/Views/CorporateResource/FinanceView/Reports";
import { ParksDetailByOccupancy, ParksDetailBySector } from "../../../pages/Views/ExecutiveView/DashboardDetail";
import InvestorList from "../../../pages/Views/Shared/Report/List/InvestorList";
import {
	ArrearReports,
	ArrearReport2,
	FinancialReport2,
	PaymentsDueAlert,
	UncollectedReport,
	FinancialSummaryReport,
	RevenueReport,
	RevenueReport2,
} from "../../../pages/Views/CorporateResource/FinanceView/Reports";
import LandInfraReports from "../../../pages/Views/LandInfraDevelopment/Head/Report/LandInfraReports";
import  RatioReport from "../../../pages/Views/LandInfraDevelopment/GISView/Reports/RatioReport"
import MarketingAndPromotionReports from "../../../pages/Views/PromotionAndMarketing/Reports/MarketingAndPromotionReports";
import DesignReportSelector from "../../../pages/Views/LandInfraDevelopment/DesignAndConstructionView/Reports/DesignReportSelector";
import ParcelListAll from "../../../pages/Views/Shared/Report/List/ParcelListAll";
import InvestorListAll from "../../../pages/Views/Shared/Report/List/InvestorListAll";
import AgreementManagementPage from "../../../pages/Views/OperationAndManagement/Forms/AgreementManagementPage";
export default function ExecutiveRoutes() {
  return (
    <>
    <Route path="/investorList" element={<InvestorListAll />} />
      <Route path="/agreementList" element={<AgreementManagementPage />} />
      <Route path="/parcelList" element={<ParcelListAll />} />
      <Route path="/" element={<ExecutiveDashboard />} />
      <Route path="/placeOnHold" element={<PlaceParcelOnHold />} />
      {/* The flf route is added */}
      <Route path="/placeOnHoldRelease" element={<PlaceParcelOnHoldRelease />} />
      <Route path="/execActivities" element={<ExecActivities />} />
      <Route path="/execFinance" element={<ExecFinance />} />
      <Route path="/viewMapByCategory" element={<ViewMapByCategoryPage />} />
      <Route path="/execReport" element={<ExecutiveReport />} />
      <Route path="/investorsList" element={<InvestorList />} />
      <Route path="/viewReferredStatus" element={<ViewReferredStatus />} />
      <Route path="/execRuleSettings" element={<ExecRuleSettings />} />
      <Route path="/parksByOccupancy" element={<ParksDetailByOccupancy />} />
      <Route path="/parksByIndustry" element={<ParksDetailBySector />} />
      <Route path="/financeSummary" element={<RevenueReport />} />
      <Route path="/arrear" element={<ArrearReport2 />} /> 
      <Route path="/financialReports" element={<FinancialReport2 />} />
      <Route path="/landInfraReports" element={<RatioReport />} />
			<Route path="/designandconstruction" element={<DesignReportSelector />} />
      <Route path="/employment" element={<EmploymentReport />} />
      <Route path="/TradeReports" element={<TradeReport />} />
      <Route path="/inverstors" element={<TradeReport />} />
      <Route path="/promReport" element={<MarketingAndPromotionReports />} />
      
    </>
  );
}